module.exports = __webpack_public_path__ + "img/i-favori-full.2ea63ba3.svg";